export const FindMaxValueJobGroup = (jobGroupArray: any[]) => {
  let maxValue = 1;
  let maxKey = '';
  jobGroupArray.forEach((item: any) => {
    if (maxValue < item.value) {
      maxValue = item.value;
      maxKey = item.key;
    }
  });

  return maxKey;
};
